module.exports = __webpack_public_path__ + "img/78.f9faba08.png";